import type { BookingBusinessEntry, BookingBusinessEntryInput } from 'owa-graph-schema';
import mapToBookingBusinessEntryInput from '../mappers/modelB2/mapToBookingBusinessEntryInput';

const getFullUpdatedBookingBusinessEntryInput = (
    oldBusinessEntry: BookingBusinessEntry,
    updatedBusinessEntryFields: BookingBusinessEntryInput
): BookingBusinessEntryInput => {
    const modifiedOldBusinessEntry = mapToBookingBusinessEntryInput(oldBusinessEntry);

    // Deep merge not required, shallow merge is enough
    const fullUpdatedBusinessEntryInput: BookingBusinessEntryInput = {
        ...modifiedOldBusinessEntry,
        ...updatedBusinessEntryFields,
    };

    /**
     * To prevent naming policy flow from breaking
     * We need to pass businessName (without prefix-suffix) field value in displayName field
     * in every update business call in B2
     */
    if (!!fullUpdatedBusinessEntryInput.businessName) {
        fullUpdatedBusinessEntryInput.displayName = fullUpdatedBusinessEntryInput.businessName;
    }

    return fullUpdatedBusinessEntryInput;
};

export default getFullUpdatedBookingBusinessEntryInput;
